<!--
 * @Author: your name
 * @Date: 2020-12-28 14:14:26
 * @LastEditTime: 2020-12-28 14:23:29
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /yunlizhi/货主端1.0/src/pages/orderManage/orderManageDetail/components/CarGps.vue
-->
<template>
  <div class="OrderStatus-root car-gps">
    <info-box title="订单状态">
      <template slot="info">
        <!-- <a-descriptions-item> -->
          <app-map-gps
            ref="appMapGps"
            class="app-map-gps"
            :start-time="formatStartTime(startTime)"
            :end-time="endTime"
            :driver-phone="orderData.realDriverPhone"
            :driver-name="orderData.driverName"
            :license-plate="orderData.licensePlate"
            :equipment-codes="equipmentCodes"
            :is-waybill="true"
            :site-start="siteStart"
            :site-end="siteEnd"
            :waybill-codes="waybillCodes"
            :waybill-status="waybillStatus"
            :is-demo="isDemo"
            :is-demo-account="isDemoData"
          />
        <!-- </a-descriptions-item> -->
      </template>
      <div slot="titleContent">
        <span class="title">轨迹追踪</span>
        <a-button class="track_btn" @click="handleTrack">查看完整轨迹</a-button>
        <a-select :value="value" class="select-wrapper" @change="handleChange">
          <a-select-option
            v-for="(item, index) in waybillList"
            :key="index"
            :value="item.id"
          >
            运单{{index+1}}
          </a-select-option>
        </a-select>
      </div>
    </info-box>
  </div>
</template>

<script>
import appMapGps from "@/components/app-map-gps";
import moment from "moment";
import { WaybillStatusText } from "@/pages/orderManage/constant.js";
import InfoBox from "./InfoBox.vue";

export default {
  name: "CarGps",
  components: {
    InfoBox,
    appMapGps,
  },
  props: {
    waybillList: {
      type: Array,
      default: () => [],
    },
    startTime: {
      type: [String, Number],
      default: "",
    },
    orderData: {
      type: Object,
      default: () => {},
    },
    isDemo: {
      type: Boolean,
      default: false,
    },
    isDemoData: {
      type: Boolean,
      default: false,
    },
    dispatch:{
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      value: '',
    };
  },
  computed: {
    endTime() {
      let endTime = "";
      if (this.waybillList.length > 0) {
        endTime = this.waybillList.filter((item) => item.id === this.value)[0]
          .signingTime;
      }
      return this.formatDate(endTime);
    },
    waybillCodes() {
      if (this.waybillList.length > 0) {
        const current = this.waybillList.find((item) => item.id === this.value)
        return current ? [current.waybillCode] : []
      }
      return []
    },
    siteStart() {
      let result = {};
      if (this.waybillList.length > 0) {
        result = this.waybillList.filter((item) => item.id === this.value)[0]
          .shippingAddress;
      }
      return [result];
    },
    siteEnd() {
      let result = {};
      if (this.waybillList.length > 0) {
        result = this.waybillList.filter((item) => item.id === this.value)[0] || {};
      }
      return [{
        ...result.receivingAddress,
        status: this.getStatusText(result.waybillStatus)
      }];
    },
    waybillStatus(){
      let result = 1;
      if (this.waybillList.length > 0) {
        result = this.waybillList.filter((item) => item.id === this.value)[0]
          .waybillStatus;
      }
      return result;
    },
    equipmentCodes(){
      if( this.dispatch?.ext?.equipmentCode) {
        return  this.dispatch?.ext?.equipmentCode?.split(',')
      }
      return []
    },
  },
  watch: {
    waybillList: {
      handler(waybillList) {
        this.value = (waybillList[0] && waybillList[0].id) || "";
      },
      immediate: true
    },
  },

  created() {},
  mounted() {},
  methods: {
    getStatusText(val) {
      let result = "-";
      WaybillStatusText.map((item) => {
        if (item.value === val) {
          result = item.label;
        }
        return item
      });
      return result;
    },
    handleChange(value) {
      this.value = value;
      this.$refs.appMapGps.queryOrderTransport();
    },
    formatDate(time) {
      if (!time) {
        return moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      }
      return moment(time).format("YYYY-MM-DD HH:mm:ss");
    },
    formatStartTime(time) {
      if (time) {
        return moment(time).format("YYYY-MM-DD HH:mm:ss");
      }
      return "";
    },
     handleTrack(){
      // 查看完整轨迹
      const {waybillCode,receivingAddressStation,shippingAddressStation} = this.waybillList.find(item=>item.id===this.value)
      this.$router.push({
        path:'/inTransitGoods',
        query:{
          waybillCode,
          startName:shippingAddressStation,
          endName:receivingAddressStation,
        }
      })
    }
  },
};
</script>

<style scoped>
.app-map-gps {
  width: 100%;
}
</style>
<style lang="less">
.car-gps {
  .ant-descriptions-item > span {
    display: block;
  }
}
.select-wrapper {
  width: 260px;
  float: right;
}

.track_btn{
  margin-left: 24px;
}
</style>
